import { Shield, Users, GraduationCap, FileCheck, Lock } from "lucide-react";

const RiskReversal = () => {
  return (
    <section className="py-24 px-8 bg-muted/30">
      <div className="max-w-[1000px] mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-light text-foreground mb-4">
            Our Commitment to You
          </h2>
          <p className="text-lg font-light text-muted-foreground max-w-[700px] mx-auto">
            We remove the risk of being an early partner
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="text-center fade-on-scroll">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
              <Shield className="w-8 h-8 text-primary" />
            </div>
            <h4 className="text-lg font-semibold mb-2">90-Day Guarantee</h4>
            <p className="text-sm text-muted-foreground leading-relaxed font-light">
              Full money-back guarantee if the platform doesn't meet specifications
            </p>
          </div>

          <div className="text-center fade-on-scroll" style={{ animationDelay: '0.15s' }}>
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
              <Users className="w-8 h-8 text-primary" />
            </div>
            <h4 className="text-lg font-semibold mb-2">Migration Team</h4>
            <p className="text-sm text-muted-foreground leading-relaxed font-light">
              Dedicated team handles all data import from your current systems
            </p>
          </div>

          <div className="text-center fade-on-scroll" style={{ animationDelay: '0.3s' }}>
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
              <GraduationCap className="w-8 h-8 text-primary" />
            </div>
            <h4 className="text-lg font-semibold mb-2">Officer Training</h4>
            <p className="text-sm text-muted-foreground leading-relaxed font-light">
              40 hours of compliance officer training included, on-site available
            </p>
          </div>

          <div className="text-center fade-on-scroll" style={{ animationDelay: '0.45s' }}>
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
              <FileCheck className="w-8 h-8 text-primary" />
            </div>
            <h4 className="text-lg font-semibold mb-2">NCAA Audit Support</h4>
            <p className="text-sm text-muted-foreground leading-relaxed font-light">
              We'll attend NCAA audit meetings with you and provide expert testimony
            </p>
          </div>

          <div className="text-center fade-on-scroll" style={{ animationDelay: '0.6s' }}>
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
              <Lock className="w-8 h-8 text-primary" />
            </div>
            <h4 className="text-lg font-semibold mb-2">Escrow Available</h4>
            <p className="text-sm text-muted-foreground leading-relaxed font-light">
              Escrow agreements available for enterprise contracts over $100K
            </p>
          </div>

          <div className="text-center fade-on-scroll" style={{ animationDelay: '0.75s' }}>
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
              <Shield className="w-8 h-8 text-primary" />
            </div>
            <h4 className="text-lg font-semibold mb-2">SOC 2 Compliant</h4>
            <p className="text-sm text-muted-foreground leading-relaxed font-light">
              Enterprise-grade security with SOC 2 Type II certification
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RiskReversal;
